import { render, staticRenderFns } from "./user-widget.vue?vue&type=template&id=40c16705&"
import script from "./user-widget.vue?vue&type=script&lang=js&"
export * from "./user-widget.vue?vue&type=script&lang=js&"
import style0 from "./user-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports